import React, { useContext, useState } from "react";
import "./CartItems.css";
import cross_icon from "../Assets/cart_cross_icon.png";
import { ShopContext } from "../../Context/ShopContext";
import { backend_url, currency } from "../../App";

const CartItems = () => {
  const {products} = useContext(ShopContext);
  const {cartItems,removeFromCart,getTotalCartAmount} = useContext(ShopContext);
  const [promoCode, setPromoCode] = useState("");
  const [discount, setDiscount] = useState(0);
  const [finalAmount, setFinalAmount] = useState(getTotalCartAmount());
  const [promoApplied, setPromoApplied] = useState(false);

  // Function to apply promo code
  const applyPromo = async () => {
  if (!promoCode) {
    alert("Enter a promo code");
    return;
  }

  const totalAmount = getTotalCartAmount();

  const res = await fetch(`${backend_url}/api/promo/apply`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "auth-token": localStorage.getItem("auth-token"),
    },
    body: JSON.stringify({
      code: promoCode,
      totalAmount,
    }),
  });

  const data = await res.json();

  if (!data.success) {
    alert("Invalid Promo Code");
    return;
  }

  setDiscount(data.discountAmount);
  setFinalAmount(data.finalAmount);
  setPromoApplied(true);
};


  const handleCheckout = async () => {
  const amount = promoApplied ? finalAmount : getTotalCartAmount();

  if (amount === 0) {
    alert("Cart is empty");
    return;
  }

  const orderRes = await fetch(`${backend_url}/create-order`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "auth-token": localStorage.getItem("auth-token"),
    },
    body: JSON.stringify({ amount }),
  });

  const orderData = await orderRes.json();
  console.log("Order Data:", orderData);
  const options = {
    key: "rzp_test_RsxmVyPQnVW7cT",
    amount: orderData.amount,
    currency: "INR",
    name: "E-Commerce Store",
    description: "Order Payment",
    order_id: orderData.id,
    handler: async function (response) {
      console.log("Razorpay Key:", process.env.REACT_APP_RAZORPAY_KEY_ID);
       console.log("Razorpay Response:", response);
      const verifyRes = await fetch(`${backend_url}/verify-payment`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "auth-token": localStorage.getItem("auth-token"),
        },
        body: JSON.stringify({
          razorpay_order_id: response.razorpay_order_id,
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_signature: response.razorpay_signature
        })
      });

      const verifyData = await verifyRes.json();

      if (verifyData.success) {
        alert("Payment Successful 🎉");
        window.location.reload();
      } else {
        alert("Payment Failed");
      }
    },
    theme: {
      color: "#3399cc",
    },
  };

  const rzp = new window.Razorpay(options);
  rzp.open();
};


  return (
    <div className="cartitems">
      <div className="cartitems-format-main">
        <p>Products</p>
        <p>Title</p>
        <p>Price</p>
        <p>Quantity</p>
        <p>Total</p>
        <p>Remove</p>
      </div>
      <hr />
      {products.map((e)=>{

        if(cartItems[e.id]>0)
        {
          return  <div key={e.id}>
                    <div className="cartitems-format-main cartitems-format">
                      <img className="cartitems-product-icon" src={backend_url+e.image} alt="" />
                      <p className="cartitems-product-title">{e.name}</p>
                      <p>{currency}{e.new_price}</p>
                      <button className="cartitems-quantity">{cartItems[e.id]}</button>
                      <p>{currency}{e.new_price*cartItems[e.id]}</p>
                      <img onClick={()=>{removeFromCart(e.id)}} className="cartitems-remove-icon" src={cross_icon} alt="" />
                    </div>
                     <hr />
                  </div>;
        }
        return null;
      })}
      
      <div className="cartitems-down">
        <div className="cartitems-total">
          <h1>Cart Totals</h1>
          <div>
            <div className="cartitems-total-item">
              <p>Subtotal</p>
              <p>{currency}{getTotalCartAmount()}</p>
            </div>
            <hr />
            <div className="cartitems-total-item">
              <p>Shipping Fee</p>
              <p>Free</p>
            </div>
            <hr />
            {promoApplied && (
  <>
    <div className="cartitems-total-item">
      <p>Discount</p>
      <p>-{currency}{discount}</p>
    </div>
    <hr />
  </>
)}

<div className="cartitems-total-item">
  <h3>Total</h3>
  <h3>
    {currency}
    {promoApplied ? finalAmount : getTotalCartAmount()}
  </h3>
</div>

          </div>
          <button onClick={handleCheckout}>
  PROCEED TO CHECKOUT
</button>
        </div>
        <div className="cartitems-promocode">
          <p>If you have a promo code, Enter it here</p>
          <div className="cartitems-promobox">
            <input type="text" placeholder="promo code" value={promoCode} 
            onChange={(e) => setPromoCode(e.target.value)} />
            <button onClick={applyPromo}>Apply Promo</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartItems;